// ສະຖານະການສຶກສາຂອງນັກສຶກສາຮຽນຕ່າງປະເທດ — ໃຊ້ຮ່ວມກັນລະຫວ່າງຟອມ, ລາຍຊື່, ປະຫວັດ ແລະ ລາຍງານ
export const STUDENT_STATUS_LABELS = {
  Active: 'ກຳລັງສຶກສາ',
  Graduated: 'ຮຽນຈົບແລ້ວ',
  Withdrawn: 'ຍົກເລີກການສຶກສາ'
};

export function studentStatusLabel(value) {
  return STUDENT_STATUS_LABELS[value] || value || '-';
}
